import { Link } from "react-router-dom";
import {
  CORPORATE_CASES,
  CORPORATE_COMPANY,
  CORPORATE_NEWS,
  CORPORATE_SOLUTIONS,
  CORPORATE_STATS,
  CORPORATE_VALUES,
} from "../CorporatePortalContent";

export default function CorporateHomePage() {
  return (
    <>
      <section className="corporate-hero">
        <div className="corporate-hero-inner">
          <div className="corporate-hero-badge">{CORPORATE_COMPANY.fullName}</div>
          <h1 className="corporate-hero-title">{CORPORATE_COMPANY.slogan}</h1>
          <p className="corporate-hero-subtitle">{CORPORATE_COMPANY.intro}</p>
          <div className="corporate-hero-actions">
            <Link to="/solutions" className="corporate-btn corporate-btn-primary">
              了解业务方向
            </Link>
            <Link to="/contact" className="corporate-btn corporate-btn-outline">
              预约咨询
            </Link>
          </div>
        </div>
      </section>

      <div className="corporate-page">
        <div className="corporate-stats-grid">
          {CORPORATE_STATS.map((item) => (
            <div key={item.label} className="corporate-stat-card">
              <div className="corporate-stat-value">{item.value}</div>
              <div className="corporate-stat-label">{item.label}</div>
            </div>
          ))}
        </div>

        <section className="corporate-section">
          <h2 className="corporate-section-title">我们的理念</h2>
          <p className="corporate-section-desc">
            从理论宣讲、实践陪伴到系统落地，帮助团队真正用好 AI，打造面向结果的组织。
          </p>
          <div className="corporate-card-grid corporate-card-grid-3">
            {CORPORATE_VALUES.map((item) => (
              <div key={item.title} className="corporate-card">
                <h3 className="corporate-card-title">{item.title}</h3>
                <p className="corporate-card-text">{item.desc}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="corporate-section">
          <h2 className="corporate-section-title">三大业务方向</h2>
          <p className="corporate-section-desc">
            AI + 组织管理、AI + 知识分享、AI + 影视制作，形成清晰的产品矩阵。
          </p>
          <div className="corporate-card-grid">
            {CORPORATE_SOLUTIONS.map((item) => (
              <div key={item.id} className="corporate-card">
                <div className="corporate-tag-list" style={{ marginTop: 0, marginBottom: 12 }}>
                  {item.tags.map((tag) => (
                    <span key={tag} className="corporate-tag">
                      {tag}
                    </span>
                  ))}
                </div>
                <h3 className="corporate-card-title">{item.title}</h3>
                <p className="corporate-card-text">{item.summary}</p>
                <ul className="corporate-highlight-list">
                  {item.highlights.map((line) => (
                    <li key={line}>{line}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
          <div style={{ marginTop: 24 }}>
            <Link to="/solutions" className="corporate-btn corporate-btn-primary">
              查看详细方案
            </Link>
          </div>
        </section>

        <section className="corporate-section">
          <h2 className="corporate-section-title">客户案例</h2>
          <p className="corporate-section-desc">真实陪跑、真实落地，帮助客户在 AI 转型上取得可衡量进展。</p>
          <div className="corporate-card-grid">
            {CORPORATE_CASES.slice(0, 2).map((item) => (
              <div key={item.id} className="corporate-card">
                <h3 className="corporate-card-title">{item.title}</h3>
                <p className="corporate-card-text">
                  {item.client} · {item.industry}
                </p>
                <p className="corporate-card-text" style={{ marginTop: 12, color: "#0b3d91" }}>
                  {item.result}
                </p>
              </div>
            ))}
          </div>
          <div style={{ marginTop: 24 }}>
            <Link to="/cases" className="corporate-btn corporate-btn-primary">
              更多客户案例
            </Link>
          </div>
        </section>

        <section className="corporate-section">
          <h2 className="corporate-section-title">业务介绍</h2>
          <div className="corporate-news-list">
            {CORPORATE_NEWS.slice(0, 3).map((item) => (
              <Link key={item.id} to={`/news/${item.id}`} className="corporate-news-item">
                <div className="corporate-news-meta">
                  <span>{item.date}</span>
                  <span>{item.category}</span>
                </div>
                <h3 className="corporate-news-title">{item.title}</h3>
                <p className="corporate-news-summary">{item.summary}</p>
              </Link>
            ))}
          </div>
        </section>
      </div>
    </>
  );
}
